import {EnumSincronizacao} from "./EnumSincronizacao";
import {Column, PrimaryGeneratedColumn} from "typeorm";

export abstract class Entidade {
    @PrimaryGeneratedColumn("uuid")
    id?: string
    @Column()
    excluido?: boolean = false
    @Column()
    situacao?: EnumSincronizacao
}
